import React from 'react';
import { useNavigate } from 'react-router-dom';
import ImageCard from '../../../reusableComponents/cards/Card43';
import Badge from '../../../reusableComponents/badges/badge3';
import { useAuth } from '../../../../context/AuthContext';
import profileImage1 from '../../../../assets/dashboard/studentProfile/image.png'

/**
 * StudentProfileCard - A card component displaying student information using existing components
 * 
 * @param {Object} props
 * @param {string} props.studentName - Student's name
 * @param {string} props.studentClass - Student's class (e.g., "CLASS III")
 * @param {string} props.identityNumber - Student's ID number
 * @param {string} props.profileImage - URL to student's profile image
 */
const StudentProfileCard = ({
  profileImage = "/api/placeholder/400/320" || profileImage1,
}) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  
  // Handle view profile navigation
  const handleViewProfile = () => {
    navigate('/profile');
  };
  
  const studentName = currentUser ? (
    `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || 
    (currentUser.email ? currentUser.email.split('@')[0] : 'Student Name')
  ) : 'Student Name';

  // Student class (this would come from your API in a real implementation)
  const studentClass = "CLASS III";

  // Student ID
  const identityNumber = currentUser?._id || '123456';

  return (
    <ImageCard
      title={studentName}
      description={`Identity number : ${identityNumber}`}
      image={profileImage1}
      showPrimaryButton={false}
      showSecondaryButton={true}
      secondaryButtonText="View Profile"
      onSecondaryClick={handleViewProfile}
      swapComponent={<Badge text={studentClass} />}
      swapLabel=""
      width="w-full"
    />
  );
};

export default StudentProfileCard;


// import React from 'react';
// import { useAuth } from '../../../context/AuthContext';

// /**
//  * StudentProfileCard - A card component displaying student information
//  */
// const StudentProfileCard = () => {
//   const { currentUser } = useAuth();
  
//   // Default profile image if none is provided
//   const defaultImage = "https://via.placeholder.com/150";
  
//   // Format student name
//   const studentName = currentUser ? 
//     `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || 
//     currentUser.email || 
//     'Student Name' : 'Student Name';
  
//   // Student class (this would come from your API in a real implementation)
//   const studentClass = "CLASS III";
  
//   // Student ID
//   const identityNumber = currentUser?._id || '123456';

//   return (
//     <div className="bg-white rounded-lg shadow overflow-hidden">
//       <div className="relative">
//         <div className="h-32 bg-gradient-to-r from-blue-500 to-blue-600"></div>
//         <div className="absolute -bottom-16 left-4">
//           <div className="h-32 w-32 rounded-full border-4 border-white overflow-hidden bg-white">
//             <img 
//               src={currentUser?.profileImage || defaultImage} 
//               alt={studentName}
//               className="h-full w-full object-cover"
//               onError={(e) => { e.target.src = defaultImage; }}
//             />
//           </div>
//         </div>
//       </div>
      
//       <div className="pt-16 pb-4 px-4">
//         <div className="flex justify-between items-start">
//           <div>
//             <h3 className="text-xl font-bold text-gray-800">{studentName}</h3>
//             <p className="text-sm text-gray-500">Identity number: {identityNumber}</p>
//           </div>
//           <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
//             {studentClass}
//           </div>
//         </div>
        
//         <button 
//           className="mt-4 w-full py-2 bg-white border border-blue-500 text-blue-500 rounded-lg hover:bg-blue-50 transition-colors"
//           onClick={() => console.log('View Profile clicked')}
//         >
//           View Profile
//         </button>
//       </div>
//     </div>
//   );
// };

// export default StudentProfileCard;
